import { createContext, useContext } from "react";
import { type useAuthState } from "./use-auth-state";

export const AuthContext = createContext<ReturnType<typeof useAuthState> | null>(null);

export const useAuth = () => {
  const value = useContext(AuthContext);

  if (!value) {
    throw new Error("useAuth must be used within `AuthProvider`");
  }

  return value;
};
